// @ts-strict-ignore
import { ArticleModelDataHolder } from '@3d-scene/model3d/cache/model-data';
import { ArticleVO } from '@article/model/vo/article.vo';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ArticleObject3DManager {

  private articleModelDataHolders: ArticleModelDataHolder[] = [];

  public addArticleObject3DData(articleModelDataHolder: ArticleModelDataHolder): void {
    if (!articleModelDataHolder) {
      return;
    }
    const article: ArticleVO = articleModelDataHolder.article;
    if (!this.findArticleModelDataHolder(article.identity, article.version)) {
      this.articleModelDataHolders.push(articleModelDataHolder);
    }
  }
  public findArticleModelDataHolder(articleId: number, articleVersion: number): ArticleModelDataHolder {
    for (const articleModelDataHolder of this.articleModelDataHolders) {
      const article: ArticleVO = articleModelDataHolder.article;
      if (articleId === article.identity && articleVersion === article.version) {
        return articleModelDataHolder;
      }
    }
    return null;
  }

  public clearAllCaches(): void {
    this.clearModelDataCache();
  }

  public clearModelDataCache(): void {
    delete this.articleModelDataHolders;
    this.articleModelDataHolders = [];
  }
}
